'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _style = require('./style');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    // 宽度，默认自适应
    width: {
      type: String,
      required: false,
      default: 'auto'
    },
    // 组件背景色
    backgroundColor: {
      type: String,
      required: false,
      default: ''
    },
    // options表示状态标识、状态名称选项，由active字段显示当前显示状态
    options: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    wrapStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    active: {
      type: Number,
      required: false,
      default: undefined
    },
    // 标识颜色
    mainTextColor: {
      type: String,
      required: false,
      default: ''
    },
    // prompt表示提示文本，数组类型，其中promptText2存在为双行，不存在为单行 [{ promptText: '预约加热至75℃', promptText2: '明天下午6:00-9:00' }]
    prompt: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 提示文本颜色
    promptTextColor: {
      type: String,
      required: false,
      default: ''
    },
    // 分格线颜色
    borderColor: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || 'default';
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    isShowMain: function isShowMain() {
      return this.options.length > 0 && this.active !== undefined;
    },

    // 默认字体颜色
    _mainTextColor: function _mainTextColor() {
      var tmp = { color: this.mainTextColor || this.themeStyle.mainTextColor };
      return tmp;
    },

    // 默认背景色
    _backgroundColor: function _backgroundColor() {
      var tmp = { backgroundColor: this.backgroundColor || this.themeStyle.backgroundColor };
      return tmp;
    },
    _wrapStyle: function _wrapStyle() {
      return _extends({
        width: this.width
      }, this._backgroundColor);
    },

    // 分格线颜色
    _borderColor: function _borderColor() {
      var tmp = this.borderColor || this.themeStyle.borderColor;
      return tmp;
    },
    _promptTextColor: function _promptTextColor() {
      var tmp = { color: this.promptTextColor || this.themeStyle.promptTextColor };
      return tmp;
    },
    wrapClass: function wrapClass() {
      var flag = false;
      this.prompt.forEach(function (element) {
        if (element.promptText2) flag = true;
      });
      return flag;
    }
  },
  data: function data() {
    return {};
  },

  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-status/index.vue
// module id = 393
// module chunks = 0 1